import copy from 'copy-to-clipboard';
import { useState, useEffect, useCallback } from 'react';

export default function useCopyReact(str) {
  const [copyableString, setStringToCopy] = useState(str)
  const [copied, setCopied] = useState(false);

  const copyAction = useCallback((str) => {
    console.log('str')
    console.log(str)
    const copiedString = copy(str);
    setCopied(copiedString);
  }, [copyableString]);

  useEffect(() => {
    setStringToCopy(str);
  }, [str]);

  return [copied, copyAction, setCopied, setStringToCopy];
}
